import { render, staticRenderFns } from "./openapi.vue?vue&type=template&id=5e070e3c"
import script from "./openapi.vue?vue&type=script&lang=ts"
export * from "./openapi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports